module.exports = __webpack_public_path__ + "static/img/calgary1.77a560c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/calgary1.jpg
// module id = 78
// module chunks = 9